import { Location } from 'vue-router'
import { Topic } from '@/typings/api/Topic'
import { Publication as Data } from '@/typings/api/Publication'

import { dateFormatter } from '@/helpers/dateFormatter'
import {
  createEdit, createView, COPY, DELETE,
} from '@/helpers/enums/table-actions'
import { PUBLICATIONS_ROUTES as ROUTES } from './utils'


const DATE_FORMAT = 'DD.MM.YYYY HH:mm'

const getEditRoute = (data: Data): Location => ({
  name: ROUTES.EDIT,
  params: { id: data.id.toString() },
})

const getViewRoute = (data: Data): Location => ({
  name: ROUTES.VIEW,
  params: { id: data.id.toString() },
})

const getTopicNames = (data: Data, topicList: Array<Topic>) => {
  if (topicList && data.topic_ids && topicList.length > 0 && data.topic_ids.length > 0) {
    return topicList.filter(({ id }) => data.topic_ids.includes(id)).map(({ name }) => name).join(', ')
  }

  return ''
}

export const TABLE_ACTIONS_ADMIN = Object.freeze([
  createView<Data>(getViewRoute),
])

export const TABLE_ACTIONS = Object.freeze([
  ...TABLE_ACTIONS_ADMIN,
  createEdit<Data>(getEditRoute),
  COPY,
  DELETE,
])


export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Название',
    value: 'name',
    sortable: false,
    getRoute: getViewRoute,
  },
  {
    text: 'Раздел(ы)',
    value: 'topic_ids',
    sortable: false,
    getTopicNames,
  },
  {
    text: 'Дата публикации',
    value: 'published_at',
    sortable: true,
    width: 136,
    field: (value: Data['published_at']) => dateFormatter(value, DATE_FORMAT),
  },
  {
    text: 'Дата завершения',
    value: 'end_at',
    sortable: true,
    width: 136,
    field: (value: Data['end_at']) => dateFormatter(value),
  },
  {
    text: 'В архиве с',
    value: 'archived_at',
    sortable: false,
    width: 130,
    field: (value: Data['archived_at']) => dateFormatter(value, DATE_FORMAT),
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: true,
    width: 130,
    field: (value: Data['updated_at']) => dateFormatter(value),
  },
  {
    text: 'Дата изменения',
    value: 'updated_at',
    sortable: true,
    width: 130,
    field: (value: Data['updated_at']) => dateFormatter(value),
  },
])
